import React, {ReactElement} from "react";

import {ConditionalFormType} from "/src/types";
import SimpleForm from "../../simple-form/SimpleForm";

const SMBRiskManagementForm = (props: ConditionalFormType): ReactElement => {
  const {conditionFields, childFields, ...simpleFormProps} = props;

  const [wantsInsurance, setWantsInsurance] = React.useState<string>("");

  const updateConditionState = (fieldName: string, val: string) => {
    // eslint-disable-next-line default-case
    switch (fieldName) {
      case "Wants_Flexport_Insurance":
        setWantsInsurance(val);
        break;
    }
  };

  const isInvisible = (fieldName: string) => {
    if (childFields.includes(fieldName)) {
      const conditions = conditionFields[fieldName];
      const conditionFieldNames = Object.keys(conditions);

      let result = true;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < conditionFieldNames.length; i++) {
        switch (conditionFieldNames[i]) {
          case "Wants_Flexport_Insurance":
            result = wantsInsurance !== conditions[conditionFieldNames[i]];
            break;
          default:
            break;
        }
      }
      return result;
    }
    return false;
  };

  return (
    <SimpleForm
      {...simpleFormProps}
      updateConditionState={updateConditionState}
      isInvisible={isInvisible}
    />
  );
};

export default SMBRiskManagementForm;
